const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#222222",
      strokeWidth: 4
    },
    d: "m 4,17 35,69 c 4,9 18,9 22,0 C 61,86 95,20 97,15 99,10 97,3 88,3 L 17,3 C 5,3 0,8 4,17 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C90000",
      stroke: "#eeeeee",
      strokeWidth: 2
    },
    d: "m 6,17 34,67 c 4,9 16,9 20,0 C 60,84 92,22 94,17 97,11 97,5 88,5 L 19,5 C 7,5 2,8 6,17 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eeeeee"
    },
    d: "m 24,15 c 4,0 47,0 55,0 4,0 5,1 2,7 0,0 -24,47 -28,54 -2,4 -4,3 -6,0 C 41,66 18,19 18,19 c -2,-4 0,-4 6,-4 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222"
    },
    d: "m 51,56 c 2,0 4,2 4,5 0,2 -2,4 -4,4 -3,0 -5,-2 -5,-4 0,-3 2,-5 5,-5 z M 35,30 c 3,-5 6,-10 16,-10 10,0 16,6 16,11 0,10 -13,10 -13,15 0,6 0,7 0,7 l -7,0 c 0,0 0,-10 0,-11 0,-6 13,-6 12,-11 -1,-4 -7,-4 -9,-4 -5,0 -9,4 -10,7 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.dbce1b7c147b245f34cd3296d7df1cd8.svg";
export { ForwardRef as ReactComponent };